import { render, staticRenderFns } from "./CadastrarApoio.vue?vue&type=template&id=41532456&scoped=true"
import script from "./CadastrarApoio.vue?vue&type=script&lang=js"
export * from "./CadastrarApoio.vue?vue&type=script&lang=js"
import style0 from "./CadastrarApoio.vue?vue&type=style&index=0&id=41532456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41532456",
  null
  
)

export default component.exports